import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutModule} from './layout/layout.module';
import {LoginComponent} from './layout/login/sso/login.component';
import {MainComponent} from './layout/main/main.component';
import {ClientService} from './services/client.service';
import {PageComponent, PreviewComponent} from '@gallaghercp/core-frontend';
import {MaintenanceComponent} from './layout/maintenance/maintenance.component';
import {LogoutComponent} from './layout/login/logout.component';
import {PrintComponent} from './pages/print.component';
import {ManualLoginComponent} from '@core-app/layout/login/manual/login.component';
import {APP_CONFIG} from '@core-app/app.config';

const routes: Routes =
    [
        ...[
            {
                path: 'maintenance',
                component: MaintenanceComponent,
            },
            {
                path: 'preview',
                component: MainComponent,
                children: [
                    {
                        path: '',
                        component: PreviewComponent,
                    }
                ]
            },
            {
                path: 'print',
                component: MainComponent,
                children: [
                    {
                        path: '',
                        component: PrintComponent,
                    }
                ]
            },
            {
                path: 'login',
                component: LoginComponent,
            }
        ],
        ...(APP_CONFIG['testManualLogin'] ||  APP_CONFIG.testMode) ? [
            {
                path: 'manual-login',
                component: ManualLoginComponent,
            }
        ] : [],
        ...[
            {
                path: 'logout',
                component: LogoutComponent,
            },
            {
                path: 'home',
                redirectTo: '/',
            },
            {
                path: '',
                component: MainComponent,
                canActivate: [ClientService],
                children: [
                    {
                        path: '',
                        component: PageComponent,
                    },
                    {
                        path: ':identifier',
                        component: PageComponent,
                    }
                ]
            },
        ],
        {
            path: '**',
            redirectTo: '/',
        }
    ];

@NgModule({
    imports: [
        LayoutModule,
        RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {
}
